import React, { PureComponent } from 'react';

import { Link, Panel } from '@philips-emr/tws-components';
import { Size } from '@philips-emr/tws-constants';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import './product-custom-link.scss';
import { eventListener, number, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { generateUUID, isFunction } from '@philips-emr/tws-utils';

import HpmsProductCustomLinkAPI from '../../api/hpms-product-custom-link-api';

@AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: HpmsProductCustomLinkAPI })
export default class HpmsProductCustomLink extends PureComponent {

  static propTypes = {
    dsPlan: string,
    nrSeqPlan: number,
    onClickLink: eventListener,
  };

  onClick() {
    const { onClickLink, nrSeqPlan } = this.props;
    isFunction(onClickLink) && onClickLink({ value: nrSeqPlan })
  }

  render() {
    const { dsPlan } = this.props;

    return (
      <Panel uuid={generateUUID()} className={'u-grid-col-12 c-custom-link'}>
        <Link value={dsPlan} onClick={() => this.onClick()} size={Size.MEDIUM} />
      </Panel>
    );
  }
}
